import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface Tab {
  title: string;
  active: boolean;
  titleClick: EventEmitter<unknown>;
}

@Component({
    selector: 'std-tab',
    templateUrl: './tab.component.html',
    styles: [],
    standalone: false
})
export class TabComponent {
  @Input() title!: string;
  @Input() active!: boolean;
  @Output() titleClick: EventEmitter<unknown> = new EventEmitter();

  onTitleClick(event: Event) {
    this.titleClick.emit(event);
  }
}
